export function appendOrderId(url: string, orderId: string): string {
  if (!url) {
    return window.location.href;
  }

  const targetUrl = new URL(url, window.location.origin);

  if (orderId) {
    targetUrl.searchParams.set("orderId", orderId);
  }

  return targetUrl.toString();
}
